import { type FC } from 'react'
import { useRightCapitalContactSync } from '../IntegrationSpecificSettings/RightCapital/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const RightCapitalCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useRightCapitalContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: false,
    isSyncDisabled: false,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
